import axios from 'axios';

const API_URL = '/api/uploads/images';

export interface ImageUploadResponse {
    url: string;
    filename: string;
    originalFilename: string;
    contentType: string;
    size: number;
}

export interface AttachmentUploadResponse {
    storedFilename: string;
    originalFilename: string;
    contentType: string;
    storagePath: string;
    size: number;
}

export interface InlineAttachmentUploadResponse {
    storedFilename: string;
    originalFilename: string;
    contentType: string;
    downloadUrl: string;
    size: number;
}

export const uploadImage = async (file: File, token: string) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(API_URL, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data as ImageUploadResponse;
};

export const uploadImageFromUrl = async (url: string, token: string) => {
    const response = await axios.post(`${API_URL}/from-url`, { url }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data as ImageUploadResponse;
};

export const uploadAttachment = async (file: File, token: string) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post('/api/uploads/attachments', formData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data as AttachmentUploadResponse;
};

export const uploadInlineAttachment = async (file: File, token: string) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post('/api/uploads/inline-attachments', formData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data as InlineAttachmentUploadResponse;
};
